<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Testing Assistant">
     Testing Assistant
    </a>
   </p>
   <p class="toc-1-style">
    <a href="change-history.html#change-history_pt" title="Hist&oacute;rico de altera&ccedil;&otilde;es">
     Hist&oacute;rico de altera&ccedil;&otilde;es
    </a>
   </p>
   <div id="divd0e8">
   </div>
   <p class="toc-1-style">
    <a href="overview-chapter.html#overview-chapter_pt" title="Vis&atilde;o geral">
     Vis&atilde;o geral
    </a>
   </p>
   <div id="divd0e56">
   </div>
   <p class="toc-1-style">
    <a href="preinstallation-checklist-chapter.html#preinstallation-checklist-chapter_pt" title="Lista de verifica&ccedil;&atilde;o da prontid&atilde;o para implanta&ccedil;&atilde;o">
     Lista de verifica&ccedil;&atilde;o da prontid&atilde;o para implanta&ccedil;&atilde;o
    </a>
   </p>
   <div id="divd0e98">
   </div>
   <p class="toc-1-style">
    <a href="using-application-chapter.html#using-application-chapter_pt" title="Utiliza&ccedil;&atilde;o do aplicativo">
     Utiliza&ccedil;&atilde;o do aplicativo
    </a>
   </p>
   <div id="divd0e134">
    <p class="toc-2-style">
     <a href="accessing-application-topic.html#accessing-application_pt" title="Acesso ao aplicativo">
      Acesso ao aplicativo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-new-term-topic.html#creating-new-term_pt" title="Criar um per&iacute;odo">
      Criar um per&iacute;odo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-class-topic.html#creating-class_pt" title="Criar uma turma">
      Criar uma turma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-test-topic.html#creating-test_pt" title="Criar uma prova">
      Criar uma prova
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-test-designer-topic.html#understanding-test-designer_pt" title="No&ccedil;&otilde;es b&aacute;sicas do recurso Designer de teste">
      No&ccedil;&otilde;es b&aacute;sicas do recurso Designer de teste
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-tests-topic.html#printing-tests_pt" title="Impress&atilde;o de provas">
      Impress&atilde;o de provas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-test-email-online-submission-topic.html#sending-test-email-online-submission_pt" title="Enviar provas por e-mail para envio on-line">
      Enviar provas por e-mail para envio on-line
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-answer-key-topic.html#creating-answer-key_pt" title="Criar um gabarito">
      Criar um gabarito
     </a>
    </p>
    <p class="toc-2-style">
     <a href="completing-online-tests-topic.html#completing-online-tests_pt" title="Concluir provas on-line">
      Concluir provas on-line
     </a>
    </p>
    <p class="toc-2-style">
     <a href="grading-tests-group.html#d0e572" title="Avaliando testes">
      Avaliando testes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-reports-topic.html#generating-reports_pt" title="Gera&ccedil;&atilde;o de relat&oacute;rios">
      Gera&ccedil;&atilde;o de relat&oacute;rios
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-reports-topic.html#understanding-reports_pt" title="Entendendo os relat&oacute;rios">
      Entendendo os relat&oacute;rios
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-data-topic.html#exporting-data_pt" title="Exportar dados">
      Exportar dados
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_pt" title="Solu&ccedil;&atilde;o de problemas">
     Solu&ccedil;&atilde;o de problemas
    </a>
   </p>
   <div id="divd0e914">
    <p class="toc-2-style">
     <a href="troubleshooting-chapter.html#trb-cannot-find-grade-test-icon_pt" title="N&atilde;o &eacute; poss&iacute;vel localizar o &iacute;cone de Corre&ccedil;&atilde;o de Prova">
      N&atilde;o &eacute; poss&iacute;vel localizar o &iacute;cone de Corre&ccedil;&atilde;o de Prova
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="leap_notices.html#leap_notices_pt" title="Avisos">
     Avisos
    </a>
   </p>
   <div id="divd0e934">
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e937" title="Aviso de edi&ccedil;&atilde;o">
      Aviso de edi&ccedil;&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e973" title="Marcas comerciais">
      Marcas comerciais
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue